export {
  ROUTE_DEVELOPER,
  ROUTE_DEVELOPER_REGISTRATION,
  ROUTE_DEVELOPER_DASHBOARD_API_REFERENCES,
  ROUTE_DEVELOPER_DASHBOARD_SANDBOXES,
  ROUTE_DEVELOPER_DASHBOARD,
  DEFINITION_ROUTE_DEVELOPER_DASHBOARD_APPLICATION,
  ROUTE_DEVELOPER_DASHBOARD_APPLICATION,
  ROUTE_DEVELOPER_ADD_NEW_APPLICATION,
  ROUTE_DEVELOPER_DASHBOARD_MY_PROFILE,
  ROUTE_DEVELOPER_REGISTRATION_CONFIRMATION,
  ROUTE_DEVELOPER_LOGIN,
  ROUTE_DEVELOPER_LANDING_REDIRECT,
  ROUTE_404,
  TERMS_OF_SERVICE,
  DEV_BEST_PRACTICES,
  DEV_README_PREFIX
} from './routes';
